var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.gameStep === 'choose-counter')?_c('div',[_c('CounterSelector')],1):(_vm.gameStep === 'choose-deck-number')?_c('div',[_c('DeckNumberSelector')],1):_c('div',[_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.show)?_c('Game'):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4edca225","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bootstrap.vue
// module id = null
// module chunks = 